import styled, { css } from 'styled-components';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ContentArea = styled.div<{ $hidden?: boolean }>`
  inline-size: 100%;
  padding-block-start: ${spacers?.spacers?.[3] ?? '1rem'};
  ${props =>
    props.$hidden &&
    css`
      display: none;
    `}
`;
